import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import logo from "../img/logo.webp";
import iso from "../img/iso.webp";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navigation = [
    { name: "Home", path: "/" },
    { name: "About Us", path: "/about" },
    { name: "Licenses", path: "/licenses" },
    { name: "Services", path: "/services" },
    { name: "Team", path: "/team" },
    { name: "Partners", path: "/client" },
    { name: "Gallery", path: "/gallery" },
    { name: "Contact Us", path: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300">
      <nav
        className={`w-full transition-all duration-300 ${
          scrolled
            ? "bg-white/90 backdrop-blur-md shadow-sm py-3"
            : "bg-white/70 backdrop-blur-sm py-4"
        }`}
        aria-label="Main Navigation"
      >
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
          
          {/* BRANDING LOGO */}
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src={logo}
              alt="PT Kamandanu Jaya Samudera"
              className="h-9 sm:h-10 w-auto object-contain transition-transform group-hover:scale-105"
            />
            <img src={iso} alt="ISO Certified" className="h-7 w-auto opacity-80 hidden sm:block" />
            <div className="flex flex-col border-l border-slate-200 pl-3">
              <span className="font-extrabold text-sm sm:text-base text-slate-900 leading-none tracking-tight">
               PT KAMANDANU JAYA <span className="text-cyan-600 font-normal">SAMUDERA</span>
              </span>
              <span className="text-[10px] text-slate-500 font-medium tracking-wider uppercase mt-0.5">
                New Website
              </span>
            </div>
          </Link>

          {/* DESKTOP MENU */}
          <div className="hidden lg:flex items-center space-x-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`px-3.5 py-2 text-sm font-semibold transition-colors rounded-full ${
                  isActive(item.path)
                    ? "text-cyan-600 font-bold"
                    : "text-slate-600 hover:text-cyan-600"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* MOBILE TOGGLE BUTTON */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-slate-700 hover:text-cyan-600"
            aria-label="Toggle Menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* MOBILE MENU DRAWER */}
        {mobileMenuOpen && (
          <div className="lg:hidden bg-white border-b border-slate-100 px-6 py-4 shadow-xl space-y-3">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`block py-2 text-sm font-semibold ${
                  isActive(item.path) ? "text-cyan-600" : "text-slate-600"
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="block text-center py-2.5 bg-cyan-600 text-white font-semibold text-sm rounded-full mt-4"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get In Touch
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;